/* global Stimulus */
console.log("template0/errors.js Loaded");

//* Stimulus
import fit_text from "../../view_components/fit_text/index.js";
Stimulus.register("fit-text", fit_text);

import parallax_divider from "../../view_components/parallax_divider/index.js";
Stimulus.register("parallax-divider", parallax_divider);
